import { SECONDARY_BUTTON } from "./buttons";

interface PagerProps {
  page: number;
  pageSize: number;
  total: number;
  onPage: (page: number) => void;
  /** Names the list, for the pager's navigation landmark. */
  label: string;
}

/** "Showing 26–50 of 202 · ‹ Previous · Next ›"; absent when one page holds everything. */
export function Pager({ page, pageSize, total, onPage, label }: PagerProps): React.ReactElement | null {
  if (total <= pageSize) return null;
  const first = (page - 1) * pageSize + 1;
  const last = Math.min(page * pageSize, total);
  const lastPage = Math.ceil(total / pageSize);
  // One text node, so the range reads (and tests match) as a single string.
  const range = `Showing ${first}–${last} of ${total}`;
  return (
    <nav aria-label={`${label} pages`} className="flex flex-wrap items-center gap-3 text-sm text-gray-700">
      <span>{range}</span>
      <button type="button" disabled={page <= 1} onClick={() => onPage(page - 1)} className={SECONDARY_BUTTON}>
        ‹ Previous
      </button>
      <button type="button" disabled={page >= lastPage} onClick={() => onPage(page + 1)} className={SECONDARY_BUTTON}>
        Next ›
      </button>
    </nav>
  );
}
